import './App.css';
import Cabecalho from './componentes/Cabecalho';
import Container from 'react-bootstrap/Container';
import { useEffect, useRef, useState } from 'react';
import Mapa from './componentes/Mapa';
import MapaResumo from './componentes/MapaResumo';

import {ThemeProvider} from "styled-components";
import { GlobalStyles } from "./componentes/Globalstyle";
import { lightTheme, darkTheme } from "./componentes/Themes";

import WebBased from './componentes/WebBased';

import {
  Routes, //replaces "Switch" used till v5
  Route,
  useNavigate,
  useLocation
} from "react-router-dom";
import Login from './componentes/Login';
import { useTranslation } from 'react-i18next';
import NotFound from './componentes/NotFound/NotFound';

import { TemaContext } from './common/context/TemaContext';
import { LinguagemContext } from './common/context/LinguagemContext';
import { UsuarioContext } from './common/context/UsuarioContext';
import Sankey from './componentes/Sankey';
import Clima1 from './componentes/Clima';
import IBP from './componentes/IBP';
import Metagenomica from './componentes/Metagenomica';
import { ServerContext } from './common/context/ServerContext';

import usePageAnalytics from "./usePageAnalytics";

function AnalyticsWrapper() {
  usePageAnalytics({ apiUrl: "https://plataforma.aesop.health/api/api/analytics/page-view" });
  return null;
}

function App() {
  const navigate = useNavigate();
  const location = useLocation();

  const { i18n } = useTranslation();

  const [language, setLanguage] = useState(localStorage.hasOwnProperty("language") ? 'en' : localStorage.getItem("language"));

  const [theme, setTheme] = useState(localStorage.hasOwnProperty("theme") ? 'dark' : localStorage.getItem("theme"));
  
  const [logado, setLogado] = useState(localStorage.hasOwnProperty("logado") ? false : localStorage.getItem("logado"));
  
  const [servidor, setServidor] = useState("https://plataforma.aesop.health/api");//useState(localStorage.hasOwnProperty("servidor") ? 'http://127.0.0.1:8000' : localStorage.getItem("servidor"));

  function getCookie(name) {
    // Cria uma expressão regular para encontrar o cookie pelo nome
    const cookieName = name + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
  
    // Percorre todos os cookies para encontrar o desejado
    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(cookieName) === 0) {
        return cookie.substring(cookieName.length, cookie.length);
      }
    }
    return "";
  }
  
  useEffect(() => {
    if(getCookie("themeCookieDashboard")){
      localStorage.setItem("theme",getCookie("themeCookieDashboard"));
      setTheme(getCookie("themeCookieDashboard"));
    } else 
    if (
      localStorage.getItem('theme') === 'light' ||
      (!('theme' in localStorage) &&
        window.matchMedia('(prefers-color-scheme: light)').matches)
    ) 
      {
        setTheme('light')
      } else {
        setTheme('dark')
      }
    
    if(getCookie("languageCookieDashboard")){
      localStorage.setItem("language",getCookie("languageCookieDashboard"));
      setLanguage(getCookie("languageCookieDashboard"));
      if(getCookie("languageCookieDashboard") === 'en'){
        i18n.changeLanguage('en-US');
      } else {
        i18n.changeLanguage('pt-BR');
      }
    } else 
    if (
      localStorage.getItem('language') === 'pt' ||
      (!('language' in localStorage))
    ) 
      {
        setLanguage('pt');
        i18n.changeLanguage('pt-BR');
      } else {
        setLanguage('en');
        i18n.changeLanguage('en-US');
      }

      /*https://programandodozero.com.br/api_new/public/api/dadosdoenca/municipiosbydate/2024-11-30/1*/
      /*setServidor("https://programandodozero.com.br/api_new");*/
      //setServidor("http://127.0.0.1/api_new")
      //setServidor("http://192.168.0.101:8000");
      //setServidor("https://programandodozero.com.br/api_new");
      //setServidor("https://aesopdev.outerlamce.com/api_new/public");
      //setServidor("https://api.controlevendas.com")
      //setServidor("http://15.228.95.135/api");
      setServidor("https://plataforma.aesop.health/api");

}, []);

useEffect(() => {
  function handleF5(e) {
    // F5 → key === "F5" (Chrome/Edge)  |  keyCode === 116 (legacy)
    if ((e.key === "F5" || e.keyCode === 116) && !e.ctrlKey) {
      e.preventDefault();              // bloqueia o reload real
      // 🔄 faça aqui o que quiser:
      // 1. buscar dados novamente…
      // myRefetch();
      // 2. ou usar React Router ↓
       navigate(0);   // força remount sem sair do SPA
      // 3. ou um window.location.reload(true) se quiser recarregar “na raça”
    }
  }

  window.addEventListener("keydown", handleF5);
  return () => window.removeEventListener("keydown", handleF5);
}, [navigate]);

  return (
    <div className={location.pathname === "/old" ? 'imagem_bg' : 'bg'} >
        <ThemeProvider theme={theme === 'light' ? lightTheme : darkTheme}>
        <>
          <UsuarioContext.Provider value={{logado, setLogado}}>
            <TemaContext.Provider value={{theme, setTheme}}>
              <LinguagemContext.Provider value={{language, setLanguage}}>
                <ServerContext.Provider value={{servidor, setServidor}}>
                  <AnalyticsWrapper />
                  <Cabecalho origem = {location.pathname} ocultaLinks = {location.pathname === "/mapa" || location.pathname === "/login" || location.pathname === "/mapa2" || location.pathname === "/sankey" || location.pathname === "/"}></Cabecalho>
                  <br></br>
                  <br></br>
                  <Container className="App">
                      <GlobalStyles/>
                        <Routes>
                          {/*<Route path="/" element={<HomeScreen language = {language} theme = {theme} />} />*/}
  
                            <Route path="/" element={<Login language = {language}/>} />
                            <Route path='/sankey' element={<Sankey language = {language}/>}/>
                            <Route path="/mapa" element={<Mapa /*MapaResumo*/ />} />
                            <Route path="/maparesumido" element={</*Mapa*/ MapaResumo />} />
                            <Route path="/mapacompleto" element={<Mapa />} />
                            <Route path='/climate' element={<Clima1 />}  />
                            {/*<Route path='/climate1' element={<Clima1 />}  />*/}
                            <Route path='/webbased' element={<WebBased />} />
                            <Route path='/ibp' element={<IBP/> } />
                            <Route path='/metagenomic' element={<Metagenomica />} />
                            <Route path='*' element={<NotFound/>} />
                        </Routes>    
                  </Container>
                </ServerContext.Provider>
              </LinguagemContext.Provider>
            </TemaContext.Provider> 
          </UsuarioContext.Provider>
        </>
      </ThemeProvider> 
    </div>
  );
}

export default App;
